import { getXhsSign } from "@saas/server-api/src/share";

const shareSdk = async (type, data) => {
  if (type === "xhs") {
    const res = await getXhsSign();
    if (res.code === 1) {
      const verifyConfig = {
        appKey: res.data.appKey,
        timestamp: res.data.timeStamp,
        signature: res.data.sign,
        nonce: res.data.nonce,
      };
      console.log(verifyConfig);

      return window.xhs.share({
        ...data,
        verifyConfig,
      });
    }
  } else if (type === "weibo") {
    const url = encodeURIComponent(data.url);
    const title = encodeURIComponent(data.title);
    const pic = encodeURIComponent(data.pic);
    console.log("微博分享》〉》〉");
    console.log(url);
    console.log(title);
    console.log(pic);

    const weiboUrl =
      "http://service.weibo.com/share/share.php?url=" +
      url +
      "?sharesource=weibo&title=" +
      title +
      "&pic=" +
      pic +
      "&appkey=388807996";
    if (window.isElectron) {
      window.openUrlByExternal(weiboUrl);
    } else {
      window.open(weiboUrl);
    }
  }
};
export default shareSdk;
